export default __webpack_public_path__ + "static/media/isometricview.62ea4484.jpg";